import { light } from "@mui/material/styles/createPalette";
import { getTheme } from "utils/themeUtils";

export const colors = {
  //black: "#020202",
  black: "#000000",
  white: "#FFFFFC",
  pink: "#FF66F9",
  green: "#CEEA39",
  purple: "#B044FF",
  drakGray: "#1A1A1A",
};

export const getThemeColor = (key) => {
  const theme = getTheme();
  return COLORS.theme[theme][key];
}

export const COLORS = {
  black: "#000000",
  white: "#FFFFFC",
  pink: "#FF66F9",
  green: "#CEEA39",
  purple: "#B044FF",
  drakGray: "#1A1A1A",
  primaryGrays: {
    p50: "#e8e9e8",
    p75: "#a0a3a2",
    p100: "#787d7b",
    p200: "#3e4542",
    p300: "#171f1b",
    p400: "#101613",
    p500: "#0e1310",
  },
  neutralGrays: {
    n50: "#f6f6f6",
    n75: "#d8d9d9",
    n100: "#c8cac9",
    n200: "#b0b3b2",
    n300: "#a0a3a2",
    n400: "#707271",
    n500: "#626363",
  },
  theme: {
    dark: {
      background: "#000000",
      box: "#1A1A1A",
      text: "#FFFFFC",
      outlinedButton: "white",
      menuIcon: "#000000",
      menuText: "#000000",
    },
    light: {
      background: "#FFFFFC",
      box: "#1A1A1A",
      text: "#FFFFFC", 
      menuIcon: "#000000",
      menuText: "#000000",
    }
  }
}


const colorToText = {
  "#000000": "black",
  "#FFFFFC": "white",
}

export const getTextFromColor = (colorHex) => {
  if(colorToText.hasOwnProperty(colorHex)) {
    const color = colorToText[colorHex];
    return color;
  }
  console.warn(`Missing color text for ${colorHex}`)
  return "black";
}


export const backgroundColors = {
  gradient: {
    start: colors.black,
    end: colors.drakGray,
  },
};

export const backgroundGradient = `linear-gradient(-45deg, ${colors.black} 0%, ${colors.drakGray} 74%)`;
